import { mapState } from 'vuex';

export default {
    name: 'userpic',
    props: {
        userid : String
    },

    data : function(){
        return {
        }
    },

    created : () => {

    }, 

    computed: mapState({
        auth : state => state.auth,

        info : state => {
            
        },

        picture : function(state){

            var pc = state.userinfo ? state.userinfo.userpicture || '' : ''

            if (pc){
                return this.gk.file(pc, 'users_picture', 'small')
            }

            return ''
        },  

        fl : state => {

            if(state.name){
                return [
                    (state.userinfo ? state.userinfo.firstname || '' : ''), 
                    (state.userinfo ? state.userinfo.lastname || '' : '')
                ]
                .map(w => !w ? '' : w.substr(0, 1))
                .join('').toUpperCase()
            }

            return ""
        }

        /*info : function(state){

            var userid = this.userid

            console.log('userid, userid', userid, state)

            return ''

        },*/


    }),

    methods : {
       
    },
}
